import { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import LocalStorageKey from 'constant/LocalStorageKey';

import { DialogWrapper } from 'component/ui/dialog/Dialog';
import TextButton from 'component/ui/button/TextButton';

import LocalStorageManager from 'manager/LocalStorageManager';

import { ReactComponent as CloseIcon } from 'static/icon/icon-close-x.svg';

const SvgWrapper = styled.div`
  cursor: ${({ showCursor }) => {
    if (showCursor) {
      return 'pointer';
    }
  }};
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
`;

const DialogButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 40px;
`;

const DoNotShowTodayWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 10px;
  color: ${(props) => props.theme.color.DARK};
  margin-left: 21px;
  gap: 3px;
  cursor: pointer;
  input {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

function NoticeDialog(props) {
  const intl = useIntl();
  const { open, params, callback, onClose, zIndex } = props;
  const { showCloseIcon, toGoUrl, handleOnclick, confirmButtonText } = params;

  const [doNotShowToday, setDoNotShowToday] = useState(false);

  const handleCloseBtnClick = () => {
    if (doNotShowToday) {
      const doNotShowTilThisDate = new Date().setHours(24, 0, 0, 0);

      LocalStorageManager.setItem(
        LocalStorageKey.DO_NOT_SHOW_NOTICE_POPUP_TIL_THIS_DATE,
        doNotShowTilThisDate
      );
    }
    onClose();
  };

  return (
    <DialogWrapper
      zIndex={zIndex ?? 12}
      open={open}
      innerStyle={{ padding: '0px', position: 'relative' }}>
      <SvgWrapper
        showCursor={toGoUrl || process.env.REACT_APP_NOTICE_DIALOG_CLICKED_URL}
        onClick={() => {
          if (toGoUrl) window.location.replace(`${toGoUrl}`);
          if (handleOnclick) handleOnclick();
        }}>
        {/* 공지 팝업 SVG 바꾸는 부분 */}
        <img src={process.env.REACT_APP_NOTICE_DIALOG_SVG_URL} alt="notice" />
      </SvgWrapper>

      {showCloseIcon && (
        <CloseIconWrapper onClick={handleCloseBtnClick}>
          <CloseIcon />
        </CloseIconWrapper>
      )}

      <DialogButtonWrapper>
        <DoNotShowTodayWrapper
          onClick={() => setDoNotShowToday((prev) => !prev)}>
          <input type="checkbox" checked={doNotShowToday} onChange={() => {}} />
          <span>오늘 다시 보지 않기</span>
        </DoNotShowTodayWrapper>
        <TextButton
          title={
            confirmButtonText ||
            intl.formatMessage({
              id: '99-Dialog-Button-title-close',
              description: '팝업 Dialog의 닫기 버튼',
              defaultMessage: '닫기',
            })
          }
          onClick={() => {
            if (typeof callback === 'function') {
              callback();
            }
            handleCloseBtnClick();
          }}
        />
      </DialogButtonWrapper>
    </DialogWrapper>
  );
}

export default NoticeDialog;
